export const prefix = 'dorik';
export const prefix_bcs = 'dorik-bcs';
export const prefix_ecs = 'dorik-ecs';
export const API_URL = process.env.REACT_APP_API_URL;
export const GRAPHQL_API_URL = API_URL + '/graphql';
export const FB_LOGIN_APP_ID = '485063998999722';
export const FB_LOGIN_APP_VERSION = 'v4.0';
export const GOOFLE_FONT_API_KEY = 'AIzaSyDizLjstb2wN1RPs2U9nSIM-B4n738Pe8I';
export const isProd = process.env.NODE_ENV === 'production';
export const release = process.env.REACT_APP_SENTRY_RELEASE;
